import { ListSortDirection, Sort } from "../../models/api/sort";
import {
  LegalEntityDonationBeneficiaryDTO,
  LegalEntityDonationBeneficiarySTO,
} from "../../models/legal-entity-donation-beneficiaries";
import { BaseApiService } from "../base/base-api.service";

export class LegalEntityDonationBeneficiariesApiService extends BaseApiService<
  LegalEntityDonationBeneficiaryDTO,
  LegalEntityDonationBeneficiarySTO
> {
  constructor() {
    super({
      servicePath: "/LegalEntityDonationBeneficiaries",
      loadItemsPath: "/GetLegalEntityDonationBeneficiaries",
      saveItemsPath: "/SaveLegalEntityDonationBeneficiaries",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
